export default __webpack_public_path__ + "static/media/logon.b6e1cd49.svg";